import React from 'react';
import Kendra from 'aws-sdk/clients/kendra';

import { DocumentResults } from './DocumentResults';
import { Pagination } from '../../pagination/Pagination';

import { PAGE_SIZE } from 'src/components/kendra-search/constants';
import { Box, SpaceBetween } from '@cloudscape-design/components';

interface ResultsPanelProps {
    results: Kendra.QueryResult;
    docResults: Kendra.QueryResultItemList;
    dataReady: boolean;
    currentPageNumber: number;
    viewStyle?: string;
    queryText: string;
    onPageChange: (queryText: string, pageNumber: number) => void;
    maxPageWithResults: number;
    totalDocumentCount: number;
}

export const ResultsPanel = ({
    results,
    docResults,
    dataReady,
    currentPageNumber,
    viewStyle = 'list-view',
    queryText,
    onPageChange,
    maxPageWithResults,
    totalDocumentCount,
}: ResultsPanelProps) => {
    let pageIndex = <span>&nbsp;</span>;

    if (
        dataReady &&
        results?.TotalNumberOfResults &&
        results.TotalNumberOfResults > 0
    ) {
        const pageStart = (currentPageNumber - 1) * PAGE_SIZE + 1;
        const pageEnd = pageStart + (results.ResultItems!.length - 1);
        pageIndex = (
            <span>
                {pageStart}-{pageEnd} of {totalDocumentCount} results
            </span>
        );
    }

    if (dataReady) {
        return (
            <SpaceBetween size="m">
                <Box variant="p" color="text-label">
                    {pageIndex}
                </Box>
                <DocumentResults results={docResults} viewStyle={viewStyle} />
                <Pagination
                    queryText={queryText}
                    currentPageNumber={currentPageNumber}
                    onSubmit={onPageChange}
                    results={results}
                    docResults={docResults}
                    maxPageWithResults={maxPageWithResults}
                />
            </SpaceBetween>
        );
    } else {
        return null;
    }
};
